import { format, startOfMonth, endOfMonth, subMonths, startOfYear } from 'date-fns';

const iso = (d) => format(d, 'yyyy-MM-dd');

export const PRESETS = [
  { key: 'this_month', label: 'Bu Ay', range: (n) => [startOfMonth(n), n] },
  { key: 'last_month', label: 'Geçen Ay', range: (n) => [startOfMonth(subMonths(n, 1)), endOfMonth(subMonths(n, 1))] },
  { key: 'last_3', label: 'Son 3 Ay', range: (n) => [startOfMonth(subMonths(n, 2)), n] },
  { key: 'this_year', label: 'Bu Yıl', range: (n) => [startOfYear(n), n] },
];

export const presetRange = (key) => {
  const p = PRESETS.find((x) => x.key === key) || PRESETS[0];
  const [s, e] = p.range(new Date());
  return { start: iso(s), end: iso(e) };
};

// Tablo/kıyas metrikleri. money: Money bileşeni ile gösterilir.
export const METRICS = [
  { key: 'routes', label: 'Rota', team: (t) => t.per_driver.routes },
  { key: 'days', label: 'Gün', team: (t) => t.per_driver.days },
  { key: 'hours', label: 'Saat', team: (t) => t.per_driver.hours, decimals: 1 },
  { key: 'km', label: 'KM', team: (t) => t.per_driver.km },
  { key: 'stops', label: 'Stop', team: (t) => t.per_driver.stops },
  { key: 'revenue', label: 'Tutar', team: (t) => t.per_driver.revenue, money: true },
  { key: 'revenue_per_hour', label: 'Tutar / saat', team: (t) => t.revenue_per_hour, money: true },
  { key: 'revenue_per_day', label: 'Tutar / gün', team: (t) => t.per_driver_day.revenue, money: true },
  { key: 'stops_per_route', label: '⌀ Stop / rota', team: (t) => t.stops_per_route, decimals: 1 },
  { key: 'km_per_route', label: '⌀ KM / rota', team: (t) => t.km_per_route, decimals: 1 },
  { key: 'hours_per_route', label: '⌀ Saat / rota', team: (t) => t.hours_per_route, decimals: 1 },
];

export const fmtNum = (v, decimals = 0) =>
  (Number(v) || 0).toLocaleString('tr-TR', { maximumFractionDigits: decimals, minimumFractionDigits: 0 });

export const pctDiff = (cur, base) => {
  if (base === null || base === undefined) return null;
  if (!base) return cur ? 100 : 0;
  return ((cur - base) / Math.abs(base)) * 100;
};

export const OPTIONAL_DATA_METRICS = ['km', 'stops', 'stops_per_route', 'km_per_route'];

export const COMPARE_COLORS = ['#0ea5e9', '#f97316', '#10b981', '#e11d48', '#8b5cf6'];
